import * as screenActions from '../../Common/actions/Screen';
import * as fieldTypes from '../../../../constants/FieldTypes';
import {showInfoMessage} from '../../../../_shared/Messages/actions/MessageActions';
import * as packagesFieldActions from './Field';
import {messagesIds} from '../../../../_shared/Messages/consts';
import {sendAnalyticsMonitor} from '../../../../utils/monitoring';

let getPackageDescServer;
let savePackagesServer;

export function initFunctions(funcs) {
    if (funcs) {
        screenActions.initFunctions(funcs);
        getPackageDescServer = funcs.getPackageDesc;
        savePackagesServer = funcs.savePackages;
        packagesFieldActions.initFunctions(funcs);
    }
}

export function saveData(screensStore, closeCallback?) {
    const {selectedScreen} = screensStore;
    const changedPackages: any = [];
    selectedScreen.collection.fields.forEach(container => {
        if (container.changed) {
            container.collection.fields.forEach(pack => {
                if (pack.changed) {
                    changedPackages.push(pack);
                }
            });
        }
    });

    if (changedPackages.length > 0) {
        savePackagesServer &&
            savePackagesServer(changedPackages, msg => {
                sendAnalyticsMonitor('Home_Packges');
                return (
                    messagesIds.screens.saveDataChangedPackagesWarn,
                    showInfoMessage({
                        title: msg,
                        onClose: () => {
                            closeCallback && closeCallback();
                        }
                    })
                );
            });
    } else {
        closeCallback && closeCallback();
    }
}

export function selectScrollField(field) {
    selectField(field);
    screenActions.scrollField(field);
}

export function selectField(field) {
    const {screen} = field;
    /* could we do without that? */
    //screensStore && screensStore.setSelectedTab(field.name);

    // processing click on unselected field
    if (!field.isSelected) {
        screen.setSelected(field);
    }
    getPackageDescription(screen);
}

function getPackageDescription(designScreen) {
    const {selected} = designScreen;
    if (selected.type !== fieldTypes.TAB) {
        getPackageDescServer &&
            getPackageDescServer(designScreen, selected.packid, updatePackageDescription);
    }
}

function updatePackageDescription(designScreen, description) {
    designScreen.selected.setDescription(description);
}

export const packagesScreenActions = {
    initFunctions
};
